function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "home-accessories_svg__cls-2",
  d: "M65.22 103.05H50.68c-13.21 0-24.56-7.87-27.61-19.15L12.16 43.52c-.43-1.58-.09-3.26.93-4.59 1.13-1.48 2.99-2.37 4.97-2.37h79.79c1.98 0 3.83.89 4.97 2.37 1.02 1.33 1.36 3 .93 4.59L92.83 83.91c-3.05 11.27-14.4 19.15-27.61 19.15zM18.05 41.57c-.5 0-.85.21-1 .41-.1.13-.08.2-.07.24L27.9 82.61c2.46 9.1 11.83 15.45 22.78 15.45h14.54c10.95 0 20.32-6.35 22.78-15.45l10.92-40.38s.03-.11-.07-.24c-.15-.2-.49-.41-1-.41h-79.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "home-accessories_svg__cls-2",
  d: "M92.3 80.75v-5c13.66 0 25.64-8.73 25.64-18.69 0-5.79-2.33-6.29-11.23-7.27-2.02-.22-4.31-.48-6.75-.87l.79-4.94c2.31.37 4.44.61 6.5.83 8.42.93 15.68 1.73 15.68 12.24 0 12.84-14.03 23.69-30.64 23.69z"
});

function SvgHomeAccessories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-accessories_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3);
}

export default SvgHomeAccessories;